import React from "react";

const Logo = ({ className = "", src = "/braveme-logo.png", imgClassName = "h-10 md:h-12" }) => {
  return (
    <a href="#top" className={`flex items-center select-none ${className}`}>
      <img
        src={src}
        alt="Brave Me"
        className={`${imgClassName} w-auto object-contain`}
      />
    </a>
  );
};

export default Logo;
